Vue.component('teamBattleQueue', {
    template: templates.teamBattleQueue,
    data() {
        return {
          model: {
            battles: {},
            hasResults: false,
            isLoading: false
          },
          cancelTokenSource: null
        };
    },
    mounted() {
        const c = this;
        c.get();
        c.connect();
    },
    beforeDestroy() {
      const c= this;
      // c.stopSendingData();
      if (c.ws) {
        c.ws.close();
      }
  
      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Request canceled due to component destruction.');
      }
    },
    methods: {
      connect() {
        const c = this;
        c.ws = new WebSocket(utils.getWsUrl());
  
        c.ws.onmessage = (event) => {

          const messageData = event.data;
          
          try {
  
            const parsedData = JSON.parse(messageData);
            if((parsedData.message === 'team_battle_accepted' || parsedData.message === 'team_requeue_battle' || parsedData.message === 'team_battle_cancelled' || parsedData.message === 'team_battle_cancelled' || parsedData.message === 'team_battle_started') && parsedData.channelId === utils.cookies.get('channelId')){
              c.model.hasResults = false;
              c.model.isLoading = false;
              c.model.battles = [];
              c.get();
            }
  
          } catch (error) {
            console.error('Error parsing message data:', error);
          }
  
        };
  
        c.ws.onopen = () => {
          console.log('WebSocket connection established');
        };
  
        c.ws.onclose = () => {
          console.log('WebSocket connection closed');
        };
      },
      get() {
        const c = this;
        let data = {};

        if (c.cancelTokenSource) {
          c.cancelTokenSource.cancel('Previous request canceled.');
        }
  
        c.cancelTokenSource = axios.CancelToken.source();

        teamBattleService
          .getQueue({ cancelToken: c.cancelTokenSource.token })
          .then(function (response) {
            if(response.data.status === 404){
              return;
            }
            c.model.hasResults = true;
            c.model.battles = response.data;
            console.log(response.data)
            // for (let d of response.data) {
            //   d.queue = true;
            //   data[`${d.id}`] = d;
            // }
            
            // c.getTwitchName(data);

            
          })
          .catch(function (error) {
            if (axios.isCancel(error)) {
              console.log('Request canceled:', error.message);
            } else {
              c.model.hasResults = false;
              console.error(error);

              console.log(c.model)
            }

          });
          
      },  
      processTwitchNames(data, result) {
        const c = this;
        
        for (let d of result) {
          for (let i in data) {
            if (data[`${i}`].user1TwitchId == d.id) {
              data[`${i}`].user1TwitchDisplayName = d.display_name;
            } else if (data[`${i}`].user2TwitchId == d.id) {
              data[`${i}`].user2TwitchDisplayName = d.display_name;
            }
          }
        }
        c.model.battles = data;
  
        setTimeout(function () {
          c.get();
        }, 10000);
      },
      start(data) {
        const c = this;
        teamBattleService.save({ id: data.id })
          .then(function (response) {
             const messageData = {
                message: 'team_battle_started',
                channelId: utils.cookies.get('channelId'),
                username1: c.getPlayerDisplayNames(data, 1),
                username2: c.getPlayerDisplayNames(data, 2)
              };

          
              c.ws.send(JSON.stringify(messageData));
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      cancel(data) {
        const c = this;
       
      //  getPlayerDisplayNames(data, 2)
        var result = confirm(
          'Are you sure you want to remove this battle from the queue?'
        );
        if (result == true) {
          teamBattleService
            .cancel({ id: data.id })
            .then(function (response) {
                const messageData = {
                    message: 'team_battle_cancelled',
                    channelId: utils.cookies.get('channelId'),
                    username1: c.getPlayerDisplayNames(data, 1),
                    username2: c.getPlayerDisplayNames(data, 2)
                };

                c.ws.send(JSON.stringify(messageData));
            })
            .catch(function (error) {
              //console.log(error);
            });
        }
      },
      getPlayerDisplayNames(battle, player){
        const c = this;
        if(player === 1){
          return [
            battle.user1TwitchDisplayName,
            battle.user2TwitchDisplayName,
            battle.user3TwitchDisplayName,
            battle.user4TwitchDisplayName
          ].filter(name => name).join(', '); 
        }
        else{
          return [
            battle.user5TwitchDisplayName,
            battle.user6TwitchDisplayName,
            battle.user7TwitchDisplayName,
            battle.user8TwitchDisplayName
          ].filter(name => name).join(', '); 
        }
  

      }
    }
})